<template>
    <multiselect
        v-model="userNameSelect.value"
        :custom-label="userNameSelectLabel"
        :options="userNameSelect.options"
        @select="userNameSelected"
        @remove="userNameRemoved"
        track-by="id"
        placeholder="Any User"
        :searchable="true"
        @search-change="asyncFind"
        :loading="isLoading"
        :internal-search="false"
        :allow-empty="true"
        :limit="5"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
    ></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Users from "../Services/Users";


    export default {
        name: "UserSelectComponent",
        props: ['centreId'],
        components: {
          Multiselect
        },
        data: () => {
            return {
                userNameSelect: {
                    value: null,
                    options: [
                    ]
                },
                isLoading: false,
            }
        },

        methods: {
            asyncFind (query) {
                this.isLoading = true;
                Users.searchByName(query, this.centreId).then(response => {
                    this.userNameSelect.options = response;
                    this.isLoading = false;
                })
            },
            userNameSelectLabel: function({id, full_name}) {
                return full_name;
            },
            userNameSelected: function (user) {
                this.$emit('select:user', user)
            },
            userNameRemoved: function (user) {
                this.$emit('remove:user', user)
            }
        }
    }
</script>

<style scoped>

</style>
